// ─── Custom Errors ──────────────────────────────────────────────
export class TrainerInviteConflictError extends Error {
    constructor(conflictUser) {
        super(`User with email ${conflictUser.email} already exists`);
        this.name = "TrainerInviteConflictError";
        this.conflictUser = conflictUser;
    }
}
